import { alpha, type Components, type Theme } from "@mui/material/styles";

export const outlinedInput: Components<Theme>["MuiOutlinedInput"] = {
  defaultProps: {
    notched: true,
  },
  variants: [
    {
      props: { color: "branded" },
      style: ({ theme }: { theme: Theme }) => ({
        backgroundColor: theme.palette.primary[600],
        color: theme.palette.common.white,
        borderRadius: theme.spacing(0.75),
        transition: "background-color 0.12s, border-color 0.12s",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.divider,
        },
        "&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: theme.palette.common.white,
            borderWidth: 1,
          },
        "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
          color: theme.palette.common.white,
          caretColor: theme.palette.common.white,
          backgroundColor: "transparent",
          "&::placeholder": {
            color: alpha(theme.palette.common.white, 0.6),
            opacity: 1,
          },
        },
        "& .MuiSelect-icon, & .MuiInputAdornment-root, & .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator":
          {
            color: theme.palette.common.white,
          },
      }),
    },
  ],
};
